import React, { useRef } from "react";
import JoditEditor from "jodit-react";

const RichEditorTipTab = ({ value, onChange }: { value: string; onChange: (v: string) => void }) => {
  const editor = useRef(null);

  return (
   

    <JoditEditor
      ref={editor}
      value={value}
      style={{
        height:500,
        overflow:"auto"
      }}
      config={{
        readonly: false,
        cleanHTML: {
          removeEmptyElements: false,
          fillEmptyParagraph: false,
        },

        pasteHTMLAction: "insert_as_html", // 🔥 key
        pasteFromWord: true,
        pasteFromWordPrompt: false,

        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        buttons: [
          "bold", "italic", "underline", "strikethrough",
          "ul", "ol", "table", "link", "source"
        ],
      }}
      onBlur={(newContent:any) => onChange(newContent)}
    />

  );
};

export default RichEditorTipTab;
